module.exports = __webpack_public_path__ + "img/0.673413dc.png";